<script lang="ts" setup>
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import type { AppMultiSelectSelectedPlaceholder } from 'libs/ui/src/lib/components/selects/models/multi.model';

import type { AppMultiSelectOption } from '@libs/ui';
import { AppMultiSelect } from '@libs/ui';
import { AccommodationType } from '@libs/trip-planner-interfaces';
import type { AccommodationProductType } from '@libs/trip-planner-interfaces';

import { HotelFilter } from '../model/hotelFilters';
import type {
  AccommodationTypeUpdate,
  PossibleAccommodationTpeFilters,
} from '../model/hotelFilters';

const { t } = i18n.global;
interface AccommodationTypeFiltersProps {
  options: AppMultiSelectOption<AccommodationProductType>[];
  useTeleport?: boolean;
  selectedPlaceholderFormat?: AppMultiSelectSelectedPlaceholder;
  shouldShowClearButton?: boolean;
  isWrapperScrolling?: boolean;
}

const props = defineProps<AccommodationTypeFiltersProps>();

interface AccommodationTypeFiltersEmits {
  (
    eventName: 'accommodation-type-option-selected',
    value: AccommodationTypeUpdate
  ): void;
  (eventName: 'clear-selection'): void;
}

const emit = defineEmits<AccommodationTypeFiltersEmits>();

function getAccommodationTypeForFilter(
  hotelType: AccommodationProductType
): PossibleAccommodationTpeFilters {
  switch (hotelType) {
    case AccommodationType.Hotel:
      return HotelFilter.AccommodationTypeHotel;
    case AccommodationType.Apartment:
      return HotelFilter.AccommodationTypeApartment;
    case AccommodationType.HouseOrCottage:
      return HotelFilter.AccommodationTypeHouseOrCottage;
  }
}

function onSelectOption(
  selectedOption: AppMultiSelectOption<AccommodationProductType>
): void {
  emit('accommodation-type-option-selected', {
    type: getAccommodationTypeForFilter(selectedOption.id),
    value: !!selectedOption.selected,
  });
}
</script>

<template>
  <AppMultiSelect
    type="modern"
    :options="props.options"
    :use-teleport="props.useTeleport"
    :placeholder="t('filter.type_of_stay')"
    :placeholder-selected="t('filter.type_of_stay')"
    :selected-placeholder-format="props.selectedPlaceholderFormat"
    should-show-clear-button
    :is-wrapper-scrolling="props.isWrapperScrolling"
    @select-single="onSelectOption"
    @clear-selection="emit('clear-selection')"
  />
</template>
